/**
 * Returns a callback to reset the map view to the original location.
 * @param {Element} component
 * @returns {Function}
 */
const handleAddressFocus = (component) => () => {
    const map = $(component).data('map');
    const location = $(component).data('location');
    const offset = Number($(component).attr('data-marker-offset')) || 50;
    const { x, y } = map.latLngToLayerPoint(location);
    const offsetLocation = map.layerPointToLatLng([x, y + offset]);
    map.panTo(offsetLocation);
};

export default handleAddressFocus;



// WEBPACK FOOTER //
// ./src/scripts/components/map/handleAddressFocus.js